import React from "react"

export const GlobalStateContext = React.createContext()
export const GlobalDispatchContext = React.createContext()

const initialState = {
  theme: "light",
  utm_source: '',
  utm_medium: '',
  utm_campaign: '',
}

function reducer(state, action) {
  switch (action.type) {
    case "TOGGLE_THEME": {
      return {
        ...state,
        theme: state.theme === "light" ? "dark" : "light",
      }
    }
    case "SET_UTM_SOURCE": {
      return {
        ...state,
        utm_source: action.payload,
      }
    }
    case "SET_UTM_CAMPAIGN": {
      return {
        ...state,
        utm_campaign: action.payload,
      }
    }
    case "SET_UTM_MEDIUM": {
      return {
        ...state,
        utm_medium: action.payload,
      }
    }
    default:
      throw new Error("Bad Action Type")
  }
}



const GlobalContextProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState)
  return (
    <GlobalStateContext.Provider value={state}>
      <GlobalDispatchContext.Provider value={dispatch}>
        {children}
      </GlobalDispatchContext.Provider>
    </GlobalStateContext.Provider>
  )
}

export default GlobalContextProvider
